import { Divider, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { INVENTORY_STATUS, INVENTORY_STATUS_LABEL } from 'utils/constants';
import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';
import styles from './Option.module.css';

const InventoryOption = ({ option, optionRef, fieldName, searchTerm }) => {
    if (!option) return null;
    const { inventoryItemType, inventoryStatus } = option;
    const inventoryName = inventoryItemType?.name;

    return (
        <>
            <Stack direction="row" justifyContent="space-between">
                <Typography fontWeight={600} ref={optionRef}>
                    <HighlightText text={option[fieldName]} searchTerm={searchTerm} />
                </Typography>
                <Typography fontSize="0.8rem">{inventoryName}</Typography>
            </Stack>
            <Divider />
            <Stack spacing={0.5}>
                <Typography fontSize="0.8rem" fontWeight={400}>
                    <span className={styles.title}>Status:</span>
                    <span className={styles[getStyle(inventoryStatus)]}>&#9679;</span>
                    {INVENTORY_STATUS_LABEL[inventoryStatus]}
                </Typography>
            </Stack>
        </>
    );
};

InventoryOption.propTypes = {
    option: PropTypes.shape({
        inventoryItemType: PropTypes.object,
        inventoryStatus: PropTypes.string,
        data: PropTypes.object,
    }),
    optionRef: PropTypes.object,
    fieldName: PropTypes.string,
    searchTerm: PropTypes.string,
};

const getStyle = (status) => (status === INVENTORY_STATUS.GOOD_TO_GO ? 'good-to-go' : 'terminated');

export default InventoryOption;
